import React from "react";

import { isAndroidHybridApp } from "../isAndroidWebView";

export function hideOnAndroidWebView<T extends {}>(
  Comp: React.VoidFunctionComponent<T>
) {
  return function HideOnAndroidWebView(props: T) {
    const [show, setShow] = React.useState(true);
    React.useEffect(() => {
      setShow(!isAndroidHybridApp());
    }, []);

    if (!show) {
      return null;
    }

    return <Comp {...props} />;
  };
}
